/**
 * Announces cart-drawer content changes (add / remove / quantity update) to
 * screen readers (WCAG 4.1.3). The header item-count badge already has its
 * own aria-live coverage; this covers the drawer's own item list and
 * subtotal, which previously updated visually with no equivalent announcement.
 *
 * Subtotal is formatted from `cart.total_price` on the event rather than read
 * from the drawer's DOM, which is replaced by a separate, unbounded fetch and
 * can race a fixed delay (announcing stale content).
 */
(function () {
  'use strict';

  function createLiveRegion() {
    var region = document.querySelector('[data-cart-update-status]');
    if (region) return region;
    region = document.createElement('div');
    region.className = 'visually-hidden';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.setAttribute('data-cart-update-status', '');
    document.body.appendChild(region);
    return region;
  }

  // Mirrors Shopify's standard money_format token replacement.
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;

    var region = createLiveRegion();

    window.setTimeout(function () {
      if (cart.item_count === 0) {
        region.textContent = 'Cart updated: your cart is empty.';
        return;
      }

      var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
      var totalText = cart.total_price === 0 ? window.theme.strings.free || 'Free' : formatMoney(cart.total_price, moneyFormat);
      var itemsLabel = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
      region.textContent = 'Cart updated: ' + itemsLabel + ', subtotal ' + totalText + '.';
    }, 150);
  });
})();
